"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Array = void 0;
const forward_1 = require("../tools/forward");
const init_1 = require("../tools/init");
const last_1 = require("../tools/last");
var Array;
(function (Array) {
    Array.concat = (arr, src) => arr.concat(src);
    Array.copyWithin = ([...arr], target, start, end) => arr.copyWithin(target, start, end);
    Array.entries = (arr) => arr.entries();
    Array.every = (arr, f) => arr.every(f);
    Array.fill = ([...arr], value, start, end) => arr.fill(value, start, end);
    Array.filter = (arr, f) => arr.filter(f);
    Array.find = (arr, f) => arr.find(f);
    Array.findIndex = (arr, f) => arr.findIndex(f);
    Array.flat = (arr, deep) => arr.flat(deep);
    Array.flatMap = (arr, f) => arr.flatMap(f);
    Array.forEach = (arr, f) => arr.forEach(f);
    Array.includes = (arr, value, start) => arr.includes(value, start);
    Array.indexOf = (arr, value, start) => arr.indexOf(value, start);
    Array.join = (arr, separator) => arr.join(separator);
    Array.keys = (arr) => arr.keys();
    Array.lastIndexOf = (arr, value, start) => start !== undefined ? arr.lastIndexOf(value, start) : arr.lastIndexOf(value);
    Array.map = (arr, f) => arr.map(f);
    Array.pop = ([...arr]) => (0, forward_1.forward)(arr.pop(), () => arr);
    Array.push = ([...arr], ...values) => (0, forward_1.forward)(arr.push(...values), () => arr);
    Array.reduce = (arr, f, initialValue) => arr.reduce(f, initialValue);
    Array.reduceRight = (arr, f, initialValue) => arr.reduceRight(f, initialValue);
    Array.reverse = ([...arr]) => arr.reverse();
    Array.shift = ([...arr]) => (0, forward_1.forward)(arr.shift(), () => arr);
    Array.slice = (arr, start, end) => arr.slice(start, end);
    Array.some = (arr, f) => arr.some(f);
    Array.sort = ([...arr], f) => arr.sort(f);
    Array.splice = ([...arr], start, nb, ...elem) => arr.splice(start !== null && start !== void 0 ? start : 0, nb !== null && nb !== void 0 ? nb : arr.length, ...elem);
    Array.toLocaleString = (arr) => arr.toLocaleString();
    Array.toString = (arr) => arr.toString();
    Array.unshift = ([...arr], v, ...values) => (0, forward_1.forward)(arr.unshift(v, ...values), () => arr);
    Array.values = (arr) => arr.values();
    Array.head = ([head,]) => head;
    Array.tail = ([, ...tail]) => tail;
    Array.init = (arr) => (0, init_1.init)(arr);
    Array.last = (arr) => (0, last_1.last)(arr);
    Array.repeat = (value, nb) => nb > 0 ? [value, ...Array.repeat(value, nb - 1)] : [];
    Array.zip = (arr1, arr2) => arr1.map((e, i) => [e, arr2[i]]);
})(Array = exports.Array || (exports.Array = {}));
//# sourceMappingURL=Array.js.map